import http, { devEnv, host } from "./httpService";
import store from "../store/Store";

export const htmlEmailSend = async (Mailto, MailCc, subject, body) => {
  return await http.post(host + "SendGenericMail", {
    Mailto: Mailto,
    MailCc: MailCc,
    strSubject: subject,
    body: body,
  });
};

export const emailStatusTractor = async (data) => {
  return await http.put(host + "UpdateEmailStatusTractor", data);
};

export const emailStatusAggregate = async (data) => {
  return await http.put(host + "UpdateEmailStatusAgg", data);
};

export const emailStatus5M = async (data) => {
  return await http.put(host + "UpdateEmailStatus5M", data);
};

export const htmlEmailSendWithAttachment = async (data) => {
  return await http.post(host + "SendGenericMailWithAttachment", data);
};

export const emailStatusContainerMasterTractor = async (data) => {
  return await http.put(host + "UpdateEmailStatusForContainerMasterTractor_AB", data);
};

export const emailStatusContainerMasterAggregate = async (data) => {
  return await http.put(host + "UpdateEmailStatusForContainerMasterAggregate_AB", data);
};

export const emailStatusContainerMasterFiveM = async (data) => {
  return await http.put(host + "UpdateEmailStatusForContainerMaster5M_AB", data);
};

export const emailStatusInvoicePackingTractor = async (data) => {
  return await http.put(host + "UpdateEmailStatusForInvoiceTractor_AB", data);
};

export const emailStatusInvoicePackingAggregate = async (data) => {
  return await http.put(host + "UpdateEmailStatusForInvoiceAggregate_AB", data);
};

export const emailStatusInvoicePackingFiveM = async (data) => {
  return await http.put(host + "UpdateEmailStatusForInvoice5M_AB", data);
};

export const emailStatusVGMTractor = async (data) => {
  return await http.put(host + "UpdateEmailStatusForVGMTractor_AB", data);
};

export const emailStatusVGMAggregate = async (data) => {
  return await http.put(host + "UpdateEmailStatusForVGMAggregate_AB", data);
};

export const emailStatusVGMFiveM = async (data) => {
  return await http.put(host + "UpdateEmailStatusForVGM5M_AB", data);
};


export var uploadDailyPlanEmailRecepients = "";
export var bookingUpdateEmailRecepients = "";
export var uploadSIEmailRecepients = "";
export var newColumnRecipientOfJD = "";
export var newColumnRecipientOfFactory = "";
export var invPackingRecepient = "";
export var VGMRecepient = "";

export var CC_uploadDailyPlanEmailRecepients = "";
export var CC_bookingUpdateEmailRecepients = "";
export var CC_uploadSIEmailRecepients = "";
export var CC_newColumnRecipientOfJD = "";
export var CC_newColumnRecipientOfFactory = "";
export var CC_newColumnRecipientOfTransporter = "";
export var CC_invPackingRecepient = "";
export var CC_VGMRecepient = "";




export function initializeRecepients(){
  if (!devEnv) {
    uploadDailyPlanEmailRecepients = store.getState().email_recepients[0]?.uploadDailyPlanEmailRecepients;
    bookingUpdateEmailRecepients = store.getState().email_recepients[0]?.bookingUpdateEmailRecepients;
    uploadSIEmailRecepients = store.getState().email_recepients[0]?.uploadSIEmailRecepients;
    newColumnRecipientOfJD = store.getState().email_recepients[0]?.newColumnRecipientOfJD;
    newColumnRecipientOfFactory = store.getState().email_recepients[0]?.newColumnRecipientOfFactory;
    invPackingRecepient = store.getState().email_recepients[0]?.invPackingRecepient;
    VGMRecepient =  store.getState().email_recepients[0]?.VGMRecepient;  
    CC_uploadDailyPlanEmailRecepients = store.getState().email_recepients[0]?.CC_uploadDailyPlanEmailRecepients;
    CC_bookingUpdateEmailRecepients = store.getState().email_recepients[0]?.CC_bookingUpdateEmailRecepients;
    CC_uploadSIEmailRecepients = store.getState().email_recepients[0]?.CC_uploadSIEmailRecepients;
    CC_newColumnRecipientOfJD = store.getState().email_recepients[0]?.CC_newColumnRecipientOfJD;
    CC_newColumnRecipientOfFactory =  store.getState().email_recepients[0]?.CC_newColumnRecipientOfFactory;
    CC_newColumnRecipientOfTransporter = store.getState().email_recepients[0]?.CC_newColumnRecipientOfTransporter;
    CC_invPackingRecepient = store.getState().email_recepients[0]?.CC_invPackingRecepient;
    CC_VGMRecepient = store.getState().email_recepients[0]?.CC_VGMRecepient;
  }
  if (devEnv) {
  uploadDailyPlanEmailRecepients = store.getState().email_recepients[1]?.uploadDailyPlanEmailRecepients;
  bookingUpdateEmailRecepients = store.getState().email_recepients[1]?.bookingUpdateEmailRecepients;
  uploadSIEmailRecepients = store.getState().email_recepients[1]?.uploadSIEmailRecepients;
  newColumnRecipientOfJD = store.getState().email_recepients[1]?.newColumnRecipientOfJD;
  newColumnRecipientOfFactory = store.getState().email_recepients[1]?.newColumnRecipientOfFactory;
  invPackingRecepient = store.getState().email_recepients[1]?.invPackingRecepient;
  VGMRecepient =  store.getState().email_recepients[1]?.VGMRecepient; 
  CC_uploadDailyPlanEmailRecepients = store.getState().email_recepients[1]?.CC_uploadDailyPlanEmailRecepients;
  CC_bookingUpdateEmailRecepients = store.getState().email_recepients[1]?.CC_bookingUpdateEmailRecepients;
  CC_uploadSIEmailRecepients = store.getState().email_recepients[1]?.CC_uploadSIEmailRecepients;
  CC_newColumnRecipientOfJD = store.getState().email_recepients[1]?.CC_newColumnRecipientOfJD;
  CC_newColumnRecipientOfFactory = store.getState().email_recepients[1]?.CC_newColumnRecipientOfFactory;
  CC_newColumnRecipientOfTransporter = store.getState().email_recepients[1]?.CC_newColumnRecipientOfTransporter;
  CC_invPackingRecepient = store.getState().email_recepients[1]?.CC_invPackingRecepient;
  CC_VGMRecepient = store.getState().email_recepients[1]?.CC_VGMRecepient;
  }
}


